var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sctaPage"},[_c('page-title',{attrs:{"back-prev":""}},[_vm._v(_vm._s(_vm.$t('pages.scta')))]),_c('div',[_c('nl2br',{attrs:{"tag":"p","text":_vm.scta}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }